import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaPlus, FaMinus, FaChevronDown, FaStar } from 'react-icons/fa';
import '../../css/accordion.css';

const Accordion = () => {
  const [openTab, setOpenTab] = useState(0);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const toggleTab = (index) => {
    setOpenTab(openTab === index ? null : index);
  };

  const testimonials = [
    {
      name: "Hồng Ngọc",
      position: "Chuyên viên SEO",
      content: "Là dân văn phòng, tôi thường xuyên sử dụng ZTO để mua hàng bên Trung Quốc. Mặt hàng khá đa dạng và chi phí vận chuyển rẻ mà nhân viên ZTO rất nhiệt tình.",
      rating: 5
    },
    {
      name: "Phương Thảo",
      position: "CEO, Founder",
      content: "Trước đây tôi vẫn thường xuyên nhập máy móc sản xuất trên Alibaba nhưng gặp khá nhiều khó khăn trong trao đổi, thanh toán và làm thủ tục nhập khẩu. Từ khi được ZTO đồng hành và hỗ trợ, công việc của tôi rất thuận lợi.",
      rating: 5
    },
    {
      name: "Quỳnh Châu",
      position: "Nhân viên kinh doanh",
      content: "Tôi mới kinh doanh quần áo được 2 năm và thật sự tình cờ được làm việc với đội ngũ ZTO, nhờ đó công việc của tôi khá thuận lợi.",
      rating: 5
    }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <div className="accordion-section mt-5">
      <Container>
        <Row className="align-items-start">
          {/* Left Column - FAQ Section */}
          <Col lg={6} className="accordion-left-panel">
            <div className="accordion-badge">CÂU HỎI THƯỜNG GẶP</div>
            <h2 className="accordion-main-title">Bạn cần hỗ trợ?</h2>

            <div className="accordion-item">
              <div
                className={`accordion-header ${openTab === 0 ? 'active' : ''}`}
                onClick={() => toggleTab(0)}
              >
                <span>Thời gian vận chuyển Trung – Việt là bao lâu?</span>
                <span className="accordion-icon">
                  {openTab === 0 ? <FaMinus /> : <FaPlus />}
                </span>
              </div>
              <div className={`accordion-content ${openTab === 0 ? 'open' : ''}`}>
                <p>
                  ZTO cam kết hàng về kho Hà Nội chỉ trong 2 ngày kể từ khi ký gửi tại kho Trung Quốc.
                </p>
              </div>
            </div>

            {/* Tab 2 */}
            <div className="accordion-item">
              <div
                className={`accordion-header ${openTab === 1 ? 'active' : ''}`}
                onClick={() => toggleTab(1)}
              >
                <span>Tôi muốn theo dõi đơn hàng thì làm như thế nào?</span>
                <span className="accordion-icon">
                  {openTab === 1 ? <FaMinus /> : <FaPlus />}
                </span>
              </div>
              <div className={`accordion-content ${openTab === 1 ? 'open' : ''}`}>
                <p>
                  Bạn có thể truy cập chức năng "Tracking" trên website, nhập mã đơn để kiểm tra trạng thái đơn hàng theo thời gian thực.
                </p>
              </div>
            </div>

            {/* Tab 3 */}
            <div className="accordion-item">
              <div
                className={`accordion-header ${openTab === 2 ? 'active' : ''}`}
                onClick={() => toggleTab(2)}
              >
                <span>Có hỗ trợ thu hộ (COD) không?</span>
                <span className="accordion-icon">
                  {openTab === 2 ? <FaMinus /> : <FaPlus />}
                </span>
              </div>
              <div className={`accordion-content ${openTab === 2 ? 'open' : ''}`}>
                <p>
                  Có. Dịch vụ Fulfillment của ZTO tích hợp cả tính năng thu hộ (COD), đối soát nhanh chóng, chính xác.
                </p>
              </div>
            </div>

            {/* Tab 4 */}
            <div className="accordion-item">
              <div
                className={`accordion-header ${openTab === 3 ? 'active' : ''}`}
                onClick={() => toggleTab(3)}
              >
                <span>Tôi là shop bán hàng, có ưu đãi riêng không?</span>
                <span className="accordion-icon">
                  {openTab === 3 ? <FaMinus /> : <FaPlus />}
                </span>
              </div>
              <div className={`accordion-content ${openTab === 3 ? 'open' : ''}`}>
                <p>
                  Chắc chắn. ZTO có chính sách giá và hỗ trợ vận hành riêng cho shop, đại lý và doanh nghiệp TMĐT. Liên hệ để nhận báo giá chi tiết.
                </p>
              </div>
            </div>

            <div className="accordion-item">
              <div
                className={`accordion-header ${openTab === 4 ? 'active' : ''}`}
                onClick={() => toggleTab(4)}
              >
                <span>Nếu hàng hóa bị hư hỏng, mất mát thì giải quyết thế nào?</span>
                <span className="accordion-icon">
                  {openTab === 4 ? <FaMinus /> : <FaPlus />}
                </span>
              </div>
              <div className={`accordion-content ${openTab === 4 ? 'open' : ''}`}>
                <p>
                  ZTO có chính sách đền bù minh bạch theo giá trị khai báo của hàng hóa, hỗ trợ xử lý sự cố nhanh chóng và chuyên nghiệp.
                </p>
              </div>
            </div>
          </Col>

          {/* Right Column - Testimonials Section */}
          <Col lg={6} className="testimonial-panel">
            <div className="testimonial-badge">ĐÁNH GIÁ CỦA KHÁCH HÀNG</div>
            <div className="testimonial-card">
              <div className="testimonial-stars">
                {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                  <FaStar key={i} className="star-icon" />
                ))}
              </div>
              <p className="testimonial-content">
                {testimonials[currentTestimonial].content}
              </p>
              <div className="testimonial-author">
                <div className="author-avatar">
                  {testimonials[currentTestimonial].name.charAt(0)}
                </div>
                <div className="author-info">
                  <h5>{testimonials[currentTestimonial].name}</h5>
                  <p>{testimonials[currentTestimonial].position}</p>
                </div>
              </div>
            </div>
            <div className="testimonial-navigation">
              <button onClick={prevTestimonial} className="nav-arrow">&lt;</button>
              <button onClick={nextTestimonial} className="nav-arrow">&gt;</button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Accordion;